import * as React from 'react';

import { PageHeaderContainer } from '../PageHeader';
import { RealtorRatingContainer } from '../RealtorRating';
import { PageOneColumn as Layout } from '../../components/Layouts';

/**
 * Контейнер страницы рейтинга риелторов
 */
export const RealtorRatingPageContainer = () => {
  return <Layout header={<PageHeaderContainer />} body={<RealtorRatingContainer />} />;
};
